export default __webpack_public_path__ + "static/media/gallery_18.b72b313f.jpg";